module.exports = __webpack_public_path__ + "static/media/tap_09_img01.3487e2ca.png";